export const environment = {
  production: true,
  apiUrl: 'https://tracey-uat-6b98eac1c8fad5e7fa6493b8d82e4fc3.byteink.hr',
  internalServicesAddress: 'http://tracey-service.tracey-uat.svc.cluster.local:8080',
  googleLoginProviderId: '918624079894-kug8r6t6go32n746040i4jhuur5su4tq.apps.googleusercontent.com',
  facebookLoginProviderId: '1131369544436247',
  toastDurationTime: 10000,
  fullTextSearchDelay: 100,

  headquartersLat: 45.80632463407991,
  headquartersLng: 15.98671633558226,
  headquartersName: 'Stotinka Ltd for electronic timing',
  headquartersStreet: 'Domagojeva 21',
  headquartersPostalNumber: 'HR-10000',
  headquartersCity: 'Zagreb',
  headquartersCountry: 'Croatia',

  officeName: 'Tehnološki Park Zagreb',
  officeStreet: 'Zagrebački velesajam, Pav. 12, Office 11',
  officePostalNumber: 'HR-10020',
  officeCity: 'Zagreb',
  officeCountry: 'Croatia',

  contactMail: 'timing@stotinka.hr',

  contactManagement: 'Zoran Besak, CEO',
  contactManagementMail: 'zoran.besak@stotinka.hr',
  contactManagementPhone: '+385 91 230 9973',

  contactHelpdesk: 'Matea Makarun',
  contactHelpdeskMail: 'matea.makarun@stotinka.hr',
  contactHelpdeskPhone: '+385 91 957 9415',

  courtRegistryLink: 'https://sudreg.pravosudje.hr/registar/f?p=150:28:0::NO:28:P28_SBT_MBS:080940043',
  courtNumber: '080940043',
  taxNumber: '21101618444',

  bankLink: 'https://www.pbz.hr',
  bankName: 'Privredna banka Zagreb d.d.',
  bankStreet: 'Radnička cesta 50',
  bankPostalNumber: 'HR-10000',
  bankCity: 'Zagreb',
  bankCountry: 'Croatia',
  bankSwiftCode: 'PBZGHR2X',
  bankIbanCode: 'HR3723400091110687781',

  supportedByTehnoParkLogo: 'assets/img/tepeze-logo.png',
  supportedByTehnoParkLink: 'http://www.tehnopark.hr/',
  supportedByTehnoParkAlt: 'Tehnološki park Zagreb',

  supportedByRazakLogo: 'assets/img/raza-logo.png',
  supportedByRazaLink: 'http://www.raza.hr/',
  supportedByRazaAlt: 'Razvojna agencija Zagreb',

  lengthDropdownMeasurementUnit: 'km',
  eventItemLengthsSizeUiBreakpoint: 3,
  liveResultRequestInterval: 3000,
  debounceActionInterval: 300,
  maxFileSize: 2 * 1024 * 1024,
  dayInSeconds: 24 * 60 * 60,
  site_name: 'traceyweb-uat',
  google_site_verification: 'th3dVJUCU14oU6awmaWDCO3VCMgQtxxOBocq7hQhCZ4',
  assetsImagesPath: 'https://traceyweb-uat-images.byteink.hr'
};
